import { signal } from "@preact/signals-react"

export const tourIsRunning = signal(false)
export const tourLanguage = signal("en")
export const tourLanguagePicked = signal(false)
export const tourStepIndex = signal(0)
export const tourShowLanguageSelector = signal(false)
export const tourDashboardIsReady = signal(false)
export const dashboardHasLoaded = signal(false)

export const resetTourSignals = () => {
    tourIsRunning.value = false
    tourStepIndex.value = 0
    tourShowLanguageSelector.value = false
    tourDashboardIsReady.value = false
    // dashboardHasLoaded NO se resetea aquí — el dashboard sigue teniendo datos
}
